import { WarningCircle } from "@phosphor-icons/react";
import { Link, useRouteError } from "react-router-dom";

export function RouteError() {
  const error = useRouteError();
  const message = error instanceof Error ? error.message : "The requested view could not be displayed.";
  return (
    <main className="page-shell fatal-error" id="main-content">
      <WarningCircle size={36} aria-hidden="true" />
      <h1>Something went wrong</h1>
      <p>{message}</p>
      <div><button className="primary-button" type="button" onClick={() => window.location.reload()}>Retry</button><Link className="secondary-button" to="/">Return to explorer</Link></div>
    </main>
  );
}
